import {createReducer} from '@reduxjs/toolkit'
import {sendRsvp} from '../actions/rsvp'

export const guest = createReducer({}, builder => {
  builder.addCase(sendRsvp.fulfilled, (_, action) => action.payload.rsvp)
})
